import { Directive, forwardRef } from "@angular/core";
import { NG_ASYNC_VALIDATORS, Validator, AbstractControl } from "@angular/forms";
import { Observable } from "rxjs";
import { Observer } from "rxjs/Observer";
import { ContactService, UniqueEmailCheckResult } from "@services/contact";

@Directive({
  selector: "[uniqueEmailAsyncValidator][formControlName]",
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: forwardRef(() => UniqueEmailAsyncValidation),
      multi: true
    }
  ]
})
export class UniqueEmailAsyncValidation implements Validator {

  constructor(
    private contactService: ContactService,
  ) {}

  validate(c : AbstractControl)  {
    return this.checkUnique(c.value).first()
  }

  checkUnique(email: string) {
    return Observable.timer(500).switchMap(() => {
      return this.contactService
        .checkUniqueEmail(email)
        .switchMap((check: UniqueEmailCheckResult) => {
          if (!check.result) {
            return Observable.of({ emailTaken: true })
          }
          else {
            return Observable.of(null)
          }
        })
    })
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/validators/unique-email-async.ts